import { QueryObserverResult, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getAuditLogSparkline } from './audit-logs-client';
import type { AuditLogSparklineApiResponse, AuditLogSparklineParams } from './audit-logs-client.type';

/**
 * Hook for fetching audit log sparkline data
 * Fetches weekly activity counts for multiple projects to display as sparklines
 *
 * @param {AuditLogSparklineParams} params Query parameters for the sparkline endpoint (project_ids required)
 * @param {UseQueryOptions<AuditLogSparklineApiResponse>} options Additional query options
 * @return Object containing:
 * - data: Sparkline data response by project ID
 * - query: QueryObserverResult for the sparkline data
 */
const useAuditLogSparkline = (
  params: AuditLogSparklineParams,
  options?: UseQueryOptions<AuditLogSparklineApiResponse>,
): {
  data: AuditLogSparklineApiResponse | undefined;
  query: QueryObserverResult<AuditLogSparklineApiResponse>;
} => {
  const query = useQuery({
    queryKey: ['auditLogSparkline', params],
    queryFn: () => getAuditLogSparkline(params),
    enabled: params.project_ids && params.project_ids.length > 0,
    ...options,
  });

  return {
    data: query.data,
    query,
  };
};

export { useAuditLogSparkline };
